import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Storage from 'src/app/Models/Base/storage';
import { Router } from '@angular/router';
import { AppStateService } from '../AppState/app-state.service';
import { getLocalStorage } from 'npx-arc-ui/utils';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor{

  constructor(private router: Router, private appStateService: AppStateService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let 
    token = getLocalStorage<string>(Storage.TOKEN)?.data,
    headers = req.headers;
    if(!!token)(
      headers = headers.append('Authorization', `Bearer ${token}`)
    );
    const new_req = req.clone({
      headers
      , withCredentials: true
    });

    return next.handle(new_req).pipe(
      catchError(err => this.handlerErrors(err))
    )
  }

  private handlerErrors(error: HttpErrorResponse){
    switch (error.status) {
      case 401:
        this.appStateService.onLogOut();
        this.router.navigate(['/login']);
        return throwError('Se produjo un error inesperado. Por favor, vuelve a iniciar sesión.');
      case 500:
        return throwError('Error de token');
      default:
        return throwError(error);
    } 
  }
}
